import { createContext, useContext } from 'react';

import { LookupRequest } from '../types';

type UserKeyLookupQueryState = {
  isError: boolean;
  isLoading: boolean;
  lookup: (query: LookupRequest) => void;
  query?: LookupRequest;
  userKey?: string;
};

export const defaultState = {
  isError: false,
  isLoading: false,
  lookup: () => null,
};

export const UserKeyLookupQueryContext = createContext<UserKeyLookupQueryState>(defaultState);

export const useUserKeyLookupQueryContext = () => useContext(UserKeyLookupQueryContext);
